export default __webpack_public_path__ + "static/media/credit_card.045b2d4a.svg";